<template>
  <div class="period-picker-header">
    <span
      class="prev period-picker-header-item"
      :class="previousClass"
      @click="showPreviousPage"
      ><i v-show="hasPreviousPage" class="fa fa-arrow-left"
    /></span>
    <span
      class="period-picker-header-item switch"
      @click="$emit('header-click')"
    >
      {{ headerText }}
    </span>
    <span
      class="next period-picker-header-item"
      :class="nextClass"
      @click="showNextPage"
    >
      <i v-show="hasNextPage" class="fa fa-arrow-right" />
    </span>
  </div>
</template>

<script>
import classNames from 'classnames'

const PeriodPickerHeader = {
  props: {
    headerText: [String, Number],
    hasPreviousPage: Boolean,
    hasNextPage: Boolean,
  },
  emits: ['show-previous-page', 'show-next-page', 'header-click'],
  computed: {
    nextClass() {
      return classNames({
        'not-visible': !this.hasNextPage,
      })
    },
    previousClass() {
      return classNames({
        'not-visible': !this.hasPreviousPage,
      })
    },
  },
  methods: {
    showPreviousPage() {
      if (this.hasPreviousPage) {
        this.$emit('show-previous-page')
      }
    },
    showNextPage() {
      if (this.hasNextPage) {
        this.$emit('show-next-page')
      }
    },
  },
}

export default PeriodPickerHeader
</script>
